import { Flex, Text } from "@chakra-ui/react";
import * as AF from "src/types/formTemplate";

type QuestionTitleProps = {
  question: AF.V2.Question;
};
export const QuestionTitle: React.FC<QuestionTitleProps> = ({ question }) => {
  return (
    <Flex gap="0" flexGrow="1" flexDirection="column">
      <Text
        as="span"
        color="blackAlpha.800"
        fontWeight="500"
        whiteSpace="pre-wrap"
        flexGrow="1"
      >
        {question.question}
      </Text>

      <Text as="span" color="blackAlpha.600" fontWeight="400">
        <Text whiteSpace="nowrap" as="span">
          Question key:{" "}
        </Text>
        {question.key}
      </Text>
    </Flex>
  );
};
